import styles from "./Designer.module.scss";
import BaseModal from "./BaseModal";
import NoDoorImage from "../../assets/images/modal_no_door.png"
import React from "react";

interface Props {
  open: boolean,
  onClose: () => void
}

function NoDoorModal({ open, onClose }: Props) {
  return (
    <BaseModal open={open} onClose={onClose}>
      <div className={styles.Modal}>
        <div className={styles.ModalTitle}>温馨提示</div>
        <div className={styles.ModalSubTitle}>无门衣柜放在家里<b>比较容易置灰</b>哦，建议可以选择合页门或者滑门来方便防尘</div>
        <div className={styles.ModalNoDoorImage}>
          <img src={NoDoorImage} alt={'designer'}/>
        </div>
        <div className={styles.ModalConfirmBtn} onClick={onClose}>我知道了</div>
      </div>
    </BaseModal>)
}

export default NoDoorModal;
